import React from 'react'
import { useRouteMatch } from 'react-router'
import { useForTablet } from '@sketch/components'
import NewFeatureHighlightPopover from 'components/NewFeatureHighlightPopover'

import {
  isDocumentRoute,
  isArtboardRoute,
  isCanvasFallbackRoute,
  isDocumentPageRoute,
  isDocumentPrototypeRoute,
  isCwvRoute,
} from 'utils/route'

interface IntroPopoverProps {
  onConfirm?: () => void
  confirmCopy?: string
  shouldShow?: boolean
  titleText?: string
  bodyText?: string
}

const IntroPopover: React.FC<IntroPopoverProps> = ({
  onConfirm,
  confirmCopy = 'Create New',
  shouldShow = true,
  titleText = 'Design Systems Made Easy',
  bodyText = 'Combine your Libraries with customizable guidelines to create your first design system in Sketch.',
  children,
}) => {
  const { path } = useRouteMatch()
  const isTabletAndBigger = useForTablet()

  if (!isTabletAndBigger) {
    return <>{children}</>
  }

  // route verification is needed because otherwise the popover will appear everywhere until it's manually closed
  const wrongRoute =
    isDocumentRoute(path) ||
    isArtboardRoute(path) ||
    isCanvasFallbackRoute(path) ||
    isDocumentPageRoute(path) ||
    isDocumentPrototypeRoute(path) ||
    isCwvRoute(path)

  const canShowPopover = !wrongRoute && shouldShow

  return (
    <NewFeatureHighlightPopover
      highlightPlacement="sidebar"
      titleText={titleText}
      bodyText={bodyText}
      confirmCopy={confirmCopy}
      onConfirm={onConfirm}
      localStorageKey="dsmIntroductionSeen"
      show={canShowPopover}
    >
      {children}
    </NewFeatureHighlightPopover>
  )
}

export default IntroPopover
